import DrillDownTable from "./components/DrillDownTable";
import PublisherDashboard from "./components/PublisherDashboard";
import { useAuth } from "./contexts/authContext";
import { Box, Typography } from "@mui/material";

function PublisherPage() {
    const { publisherId } = useAuth()
    function publisherName() {
        if (publisherId.toLowerCase() === 'p4310319811') {
            return "Emerald Publishing"
        } else if (publisherId.toLowerCase() === 'p4310316297') {
            return "Impact Journals"
        } else {
            return "Publisher"
        }
    }

    return <>
        <Typography gutterBottom variant="h3" component="div" sx={{ color: '#003366', fontWeight: 'bold' }}>
            {publisherName()} Dashboard
        </Typography>
        <PublisherDashboard publisherId={publisherId} />
        <Box p={2} />
    </>

}

export default PublisherPage;